// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.basic.Switch

@Composable
fun SwitchDemo() {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(demoBackground()),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            Modifier
                .padding(16.dp)
                .widthIn(max = 600.dp)
                .fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(16.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            var switch1 by remember { mutableStateOf(false) }
            var switch2 by remember { mutableStateOf(true) }
            Row(
                horizontalArrangement = Arrangement.spacedBy(32.dp),
            ) {
                Switch(
                    checked = switch1,
                    onCheckedChange = { switch1 = it },
                )
                Switch(
                    checked = switch2,
                    onCheckedChange = { switch2 = it },
                )
                Switch(
                    checked = false,
                    onCheckedChange = { },
                    enabled = false,
                )
                Switch(
                    checked = true,
                    onCheckedChange = { },
                    enabled = false,
                )
            }
        }
    }
}
